import { Bolt, Disc3, Forklift, Drill, Cog, Cpu, Zap, Sparkles, Droplets, Package } from 'lucide-react';

// Ícones de linha por categoria (substituem os emojis guardados na BD)
const RULES = [
  [/acess/i, Bolt],
  [/disco|ponte/i, Disc3],
  [/eleva|desloca|grua|ventosa/i, Forklift],
  [/manua/i, Drill],
  [/m[áa]quinas div/i, Cog],
  [/cnc/i, Cpu],
  [/eletrodep|electrodep/i, Zap],
  [/polim/i, Sparkles],
  [/massa|cola/i, Droplets],
];

export const categoryIcon = (name = '') => (RULES.find(([re]) => re.test(name)) || [null, Package])[1];

const CategoryIcon = ({ name, className = 'w-4 h-4', strokeWidth = 1.75 }) => {
  const Icon = categoryIcon(name);
  return <Icon className={className} strokeWidth={strokeWidth} aria-hidden="true" />;
};

export default CategoryIcon;
